<template>
  <div class="emotion-stats">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>情感统计</span>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="开始日期">
          <el-date-picker v-model="searchForm.start_date" type="date" placeholder="请选择开始日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="searchForm.end_date" type="date" placeholder="请选择结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="stats-content">
        <el-card class="stats-card">
          <template #header>
            <div class="card-title">情感分布</div>
          </template>
          <div class="chart-container">
            <!-- 这里应该是图表，暂时使用模拟数据 -->
            <div class="chart-placeholder">
              <div class="chart-item">
                <div class="chart-label">积极</div>
                <div class="chart-bar" style="width: 60%"></div>
                <div class="chart-value">60%</div>
              </div>
              <div class="chart-item">
                <div class="chart-label">中性</div>
                <div class="chart-bar" style="width: 30%"></div>
                <div class="chart-value">30%</div>
              </div>
              <div class="chart-item">
                <div class="chart-label">消极</div>
                <div class="chart-bar" style="width: 10%"></div>
                <div class="chart-value">10%</div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="stats-card">
          <template #header>
            <div class="card-title">情感趋势</div>
          </template>
          <div class="chart-container">
            <!-- 这里应该是图表，暂时使用模拟数据 -->
            <div class="chart-placeholder">
              <div class="trend-chart">
                <div class="trend-item" style="height: 60%"></div>
                <div class="trend-item" style="height: 70%"></div>
                <div class="trend-item" style="height: 50%"></div>
                <div class="trend-item" style="height: 80%"></div>
                <div class="trend-item" style="height: 65%"></div>
                <div class="trend-item" style="height: 75%"></div>
                <div class="trend-item" style="height: 90%"></div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'EmotionStats',
  data() {
    return {
      searchForm: {
        start_date: null,
        end_date: null
      }
    }
  },
  mounted() {
    // 初始化数据
  },
  methods: {
    handleSearch() {
      console.log('搜索情感统计数据:', this.searchForm)
      // 这里应该调用API获取统计数据
    }
  }
}
</script>

<style scoped>
.emotion-stats {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.stats-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.stats-card {
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
}

.chart-container {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}

.chart-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chart-label {
  width: 80px;
  font-size: 14px;
}

.chart-bar {
  flex: 1;
  height: 20px;
  background-color: #409eff;
  border-radius: 10px;
}

.chart-value {
  width: 60px;
  text-align: right;
  font-size: 14px;
  font-weight: bold;
}

.trend-chart {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 200px;
  width: 100%;
  padding: 0 20px;
}

.trend-item {
  flex: 1;
  background-color: #409eff;
  border-radius: 5px 5px 0 0;
  min-height: 20px;
}

@media (max-width: 768px) {
  .stats-content {
    grid-template-columns: 1fr;
  }
}
</style>
